<template>
  <div class="camp1path2" v-if="path == 2">
    <div class="path">
        
        <div :class="openedTile !== 0 ? 'step-content open' : 'step-content'">

            <a v-if="openedTile !== 0" class="back-to-list" @click="closeTile"><span>&lt;</span> Back to the list</a>

            <a v-if="openedTile === 0" class="close" @click="voidPath()"><span>x</span></a>

            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 6 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->
            
            <ul v-if="openedTile === 0" :class="('nav step' + step)">
                <li><a class="step1" @click="goto(1)">Setting the Table <span :class="(getProgress(1) + 'progress p'+ progress1)"></span></a></li>
                <li><a class="step2" @click="goto(2)">Governance <span :class="(getProgress(2) + 'progress p'+ progress2)"></span></a></li>
                <li><a class="step3" @click="goto(3)">Vision & Values <span :class="(getProgress(3) + 'progress p'+ progress3)"></span></a></li>
                <li><a class="step4" @click="goto(4)">Leadership <span :class="(getProgress(4) + 'progress p'+ progress4)"></span></a></li>
                <li><a class="step5" @click="goto(5)">Financing <span :class="(getProgress(5) + 'progress p'+ progress5)"></span></a></li>
            </ul>

            <div v-if="step == 1">
                <h1 v-if="openedTile === 0">Setting the Table</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('1.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('1.1')" class="preview" @click="showTile('1.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Do you want this business to become a multi-gen enterprise and why?">
                            </div>
                            <div class="description">
                                <strong>Do you want this business to become a multi-gen enterprise and why?</strong> <!--Every business family has a unique character. Yet, each family business springs forth from a cultural tradition that expresses the values, thinking, and behaviours of its homeland. Enterprises achieving success often expand to new environments, encountering families and businesses with different values from diverse cultures-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.1')" class="item-content">
                            <h2>When the times comes to transition the leadership of the family business, which of the following best describes the transition you expect for the family business?</h2>

                            <ul class="quiz">
                                <li :class="(q11 == 1 ? 'checked' : '')" @click="sc('q11', 1)">Within the family</li>
                                <li :class="(q11 == 2 ? 'checked' : '')" @click="sc('q11', 2)">Outside the family</li>
                                <li :class="(q11 == 3 ? 'checked' : '')" @click="sc('q11', 3)">Transitioning to nonfamily leadership (e.g. CEO)</li>
                                <li :class="(q11 == 4 ? 'checked' : '')" @click="sc('q11', 4)">Not sure</li>
                            </ul>

                         

                            <h2>How important are each of the following for you and the rest of the family that are involved in the family business?</h2>
                            <ul class="likert-statement">
                                <li>
                                    <label class="statement">Building a sustainable business for my family</label>
                                    <ul class='likert likert5'>
                                        
                                        <li>
                                            <input v-model="likertl111" type="radio" id="l1a1" name="likertl111" value="extremely_important" @click="sc('likertl111', 'extremely_important')">
                                            <label for="l1a1">Extremely Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl111" type="radio" id="l1a2" name="likertl111" value="very_important" @click="sc('likertl111', 'very_important')">
                                            <label for="l1a2">Very Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl111" type="radio" id="l1a3" name="likertl111" value="somewhat_important" @click="sc('likertl111', 'somewhat_important')">
                                            <label for="l1a3">Somewhat Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl111" type="radio" id="l1a4" name="likertl111" value="somewhat_not_important" @click="sc('likertl111', 'somewhat_not_important')">
                                            <label for="l1a4">Somewhat not Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl111" type="radio" id="l1a5" name="likertl111" value="not_important" @click="sc('likertl111', 'not_important')">
                                            <label for="l1a5">Not Important</label>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <label class="statement">Having someone within the family to take over the business</label>
                                    <ul class='likert likert5'>
                                        <li>
                                            <input v-model="likertl112" type="radio" id="l2a1" name="likertl112" value="extremely_important" @click="sc('likertl112', 'extremely_important')">
                                            <label for="l2a1">Extremely Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl112" type="radio" id="l2a2" name="likertl112" value="very_important" @click="sc('likertl112', 'very_important')">
                                            <label for="l2a2">Very Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl112" type="radio" id="l2a3" name="likertl112" value="somewhat_important" @click="sc('likertl112', 'somewhat_important')">
                                            <label for="l2a3">Somewhat Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl112" type="radio" id="l2a4" name="likertl112" value="somewhat_not_important" @click="sc('likertl112', 'somewhat_not_important')">
                                            <label for="l2a4">Somewhat not Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl112" type="radio" id="l2a5" name="likertl112" value="not_important" @click="sc('likertl112', 'not_important')">
                                            <label for="l2a5">Not Important</label>
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <label class="statement">Working together as a family</label>
                                    <ul class='likert likert5'>
                                        <li>
                                            <input v-model="likertl113" type="radio" id="l3a1" name="likertl113" value="extremely_important" @click="sc('likertl113', 'extremely_important')">
                                            <label for="l3a1">Extremely Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl113" type="radio" id="l3a2" name="likertl113" value="very_important" @click="sc('likertl113', 'very_important')">
                                            <label for="l3a2">Very Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl113" type="radio" id="l3a3" name="likertl113" value="somewhat_important" @click="sc('likertl113', 'somewhat_important')">
                                            <label for="l3a3">Somewhat Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl113" type="radio" id="l3a4" name="likertl113" value="somewhat_not_important" @click="sc('likertl113', 'somewhat_not_important')">
                                            <label for="l3a4">Somewhat not Important</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl113" type="radio" id="l3a5" name="likertl113" value="not_important" @click="sc('likertl113', 'not_important')">
                                            <label for="l3a5">Not Important</label>
                                        </li>
                                    </ul>
                                </li>
                            </ul>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://familyenterprise.ca/resource/from-traditional-to-blended-cultures-how-family-enterprises-manage-transitions-across-generations/" target="_blank">From Traditional to Blended Cultures: How Family Enterprises Manage Transitions Across Generations</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous hide"></a>
                                <a class="next" @click="showTile('1.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('1.2')" class="preview" @click="showTile('1.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Is the enterprise fit for enduring?">
                            </div>
                            <div class="description">
                                <strong>Is the enterprise fit for enduring?</strong> <!--Family enterprises have a unique family enterprise advantage, often called the “familiness advantage”. The familiness advantage comes from the integration of the family, its individual family members, and the business with one another. This combination of valuable attributes brings a competitive advantage that often cannot be copied, benefitting from the interfacing of all the resources together.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.2')" class="item-content">
                            
                            <div class="block">
                                
                                <h1>Are you a “Family Enterprise” or a Family that owns an Enterprise?</h1>
                                <div class="res-author">Jeff Halpern, CPA, CA, TEP, FEA </div>
                                <div class="res-date">Published: Jul 16, 2020</div>  
                                
                                <p>As a professional Family Enterprise Advisor (FEA), the first question I must ask business owners is, are you a Family Enterprise?</p>

                                <p>A family enterprise is much more than a family business. A family enterprise comprises the holistic dimensions of the family individuals, together with all aspects of the family wealth, consisting of the operating business, financial assets, real estate, heirloom assets (e.g. cottages, art, etc.), philanthropic interests, deferred assets like life insurance, and human/non-financial assets such as the intellectual, social, and spiritual values of the family.</p>

                                <p>Family enterprises have a unique family enterprise advantage, often called the “familiness advantage”. The familiness advantage comes from the integration of the family, its individual family members, and the business with one another. This combination of valuable attributes brings a competitive advantage that often cannot be copied, benefitting from the interfacing of all the resources together.</p>

                                <p>When several multi-generational enterprise families were interviewed to help explain why they were so successful in being able to maintain, grow and transition their enterprises for so many generations, the answer most frequently cited was that “we put the family enterprise above ourselves”. That means they successfully implemented a transition framework and techniques to enable decisions and actions within the wider family unit for the welfare and best interest of the family enterprise, rather than just for themselves.</p>

                                <p>The characteristics of a healthy family enterprise include strong open communication, an independent board of directors, transparency and high trust among all interested parties, a formal succession plan, strong leadership with performance measurement, clear boundaries, good corporate governance mechanisms, an alignment of purpose between individual and family, and above all shared values. One of the many techniques to foster open communication in the family is a family meeting. Effective family meetings typically have an independent moderator, and encompass four cornerstones consisting of: 1) family development, 2) family cohesion, 3) family enterprise, and 4) family fun.</p>

                                <p>If it were easy to be a successful multi-generational family enterprise, frankly, more families would have chosen this route, and fewer families would have sold off their valuable businesses.&nbsp; But the truth is, it is not easy to be a successful family enterprise, as it requires collaboration, trust, hard work, and the help of skilled family enterprise advisors to guide the process.&nbsp;</p>

                                <p>Family Enterprise Canada offers a specialist program leading to a designation for family enterprise advisors, called FEAs.&nbsp; The FEA designation reflects the fact that the advisor has completed the very detailed year long course work, live family case work, and a written and an oral examination to prove their expertise.&nbsp; FEAs are an ideal choice of advisor to assist business families in developing transition strategies to optimize the family enterprise advantage, and working out the issues that may be preventing.</p>

                                <p>Advisors to families who wish to have a successful family enterprise know there are three overlapping interested parties who must be considered in relation to family enterprise planning, including: 1) Family Members, 2) Owners, and 3) the Business (i.e. Management), referred to as the “Three-Circle Model”.&nbsp; The Three-Circle Model was developed at the Harvard Business School by Renato Tagiuri and John Davisat. The three circles overlap, to produce a venn diagram, with seven different perspectives to consider when optimizing family enterprise planning.</p>

                                <p>Issues can arise in all three circles and their overlaps, including voice versus vote, vision/goals, rivalry, governance weaknesses, communication and relationship breakdown, the need for formal legal agreements, conflict management, alignment of strategy, performance measurement, unclear policies, need for education, trust and control issues, and nepotism.</p>

                                <p>A professional FEA is trained to treat the family enterprise as a whole system.&nbsp; A system is a network of independent components that work together to try to accomplish the aim of the system.&nbsp; There are five principles when taking a systematic approach to family business:</p>

                                <ul>
                                    <li>The whole is greater than the sum of its parts</li>
                                    <li>Organizations seek “homeostasis” (i.e. they like to keep the status quo)</li>
                                    <li>Patterns of behavior are predictable</li>
                                    <li>Every action creates a non-linear reaction</li>
                                    <li>Interfacing life cycles imply constant change (…and there are many life cycles to consider for the owners, business, industry, individuals, the family as a unit, etc.) &nbsp;</li>
                                </ul>

                                <p>With all the complexities that can predictably arise, and the tendency for clashes to arise in the absence of careful planning using the expertise of a specialist FEA, and the input of a multi-disciplinary team of advisors, there is a tendency for family business families to fall into traps that prevent them from being successful family enterprise families, and otherwise allowing the enterprise to remain in the family for generations to come.</p>

                                <p>There are 5 key elements to ensure continuity of a successful family enterprise, which intertwine to add strength to the enterprise, including:</p>

                                <ul>
                                    <li>Business strategy – clear definition and agreement of where the business is headed under strong leadership</li>
                                    <li>Wealth integration – to use all the resources of the family enterprise to assure success</li>
                                    <li>Intrapersonal clarity – roles and responsibilities defined with low risk of dissention</li>
                                    <li>Ownership alignment – the goals, mindset and benefits of ownership are aligned</li>
                                    <li>Governance formalization – clear need for systems to maximize continuity success</li>
                                </ul>

                                <p>The FEA designation is still quite new in Canada, with fewer than 500 across the nation.&nbsp; The expertise of FEAs is unparalleled against other business advisor qualifications, and should play a formidable role as part of the multi-disciplinary team in any business transition strategy.</p>

                                <hr class="wp-block-separator">

                                <p><strong>Jeff Halpern</strong>, CPA, CA, TEP, FEA is a 2020 graduate of the FEA program, and works as a Business Succession Advisor at TD Wealth. He has practiced for more than 40 years as a CPA and cross-border tax advisor to business owners around the world, but freely admits that the dimension of his skills was significantly enhanced from the FEA program.</p>
  
  
                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/the-future-of-family-enterprise-what-options-are-available/" target="_blank">The Future of Family Enterprise: What Options are Available</a></li>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/a-healthy-family-supports-a-healthy-business/" target="_blank">A Healthy Family Supports a Healthy Business</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('1.1')">Previous</a>
                                    <a class="next" @click="showTile('1.3')">Next</a>
                                </div>

                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('1.3')" class="preview" @click="showTile('1.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/forbes.jpg'" alt="Look at the trends in the industry and business lifecycles">
                            </div>
                            <div class="description">
                                <strong>Look at the trends in the industry and business lifecycles</strong> <!--Every business goes through four phases of a life cycle: startup, growth, maturity and renewal/rebirth or decline. Understanding what phase you are in can make a huge difference in the strategic planning and operations of your business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.3')" class="item-content">
                            <h1>Business Life Cycle Spectrum: Where Are You?</h1>

                            <a href="https://www.forbes.com/sites/theyec/2018/01/11/business-life-cycle-spectrum-where-are-you/?sh=31580db4ef5e" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-2-1.3.jpg'" style="max-width: 80%; height: auto;" alt="Business Life Cycle Spectrum: Where Are You?">
                            </a>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://corporatefinanceinstitute.com/resources/knowledge/strategy/industry-analysis-methods/" target="_blank">Industry Analysis</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.2')">Previous</a>
                                <a class="next" @click="showTile('1.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('1.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('1.4')" class="preview" @click="showTile('1.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo62263715.jpg'" alt="Intergenerational Management">
                            </div>
                            <div class="description">
                                <strong>Intergenerational Management</strong> <!--Listen to Professor John Davis talk about the importance of reinforcing partnering between the junior and senior generations in a family business. In a family business, it is important to familiarize the rising generation with the business early on, so that they can take on responsibilities sooner. Family businesses should also recognize that they can benefit from the younger generation, who are more informed on emerging technology trends.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.4')" class="item-content">
                            <div class="block">
                                <h1>Interaction Between The Junior and Senior Generations in a Family Business</h1>
                                <div class="res-author">Professor John Davis</div>
                                <div class="res-date">Published: May 3, 2011</div> 
                                
                                <p>Watch Professor John Davis of Harvard Business School talk about the importance of reinforcing partnering between the junior and senior generations in a family business. In a family business, it is important to familiarize the rising generation with the business early on, so that they can take on responsibilities sooner. Family businesses should also recognize that they can benefit from the younger generation, who are more informed on emerging technology trends.</p>

                                <iframe src="https://player.vimeo.com/video/62263715?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                                <!--div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="link"><a :href="baseurl + ''" target="_blank"></a></li>
                                    </ul>
                                </div-->

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('1.3')">Previous</a>
                                    <a class="next" @click="showTile('1.5')">Next</a>
                                </div>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('1.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('1.5')" class="preview" @click="showTile('1.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Should family members stay involved in the running of the business (leadership vs ownership)">
                            </div>
                            <div class="description">
                                <strong>Should family members stay involved in the running of the business (leadership vs ownership)</strong> <!--Take a moment to indicate whether you agree or disagree with the following statrements-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.5')" class="item-content">
                            <h2>Do you agree or disagree with the following statements?</h2>

                            <ul class="likert-statement">
                                <li class="statement">I think of the family business as a legacy to leave future generations
                                    <ul class='likert'>
                                        <li>
                                            <input v-model="likertl151" type="radio" id="l1a1" name="likertl151" value="agree" @click="sc('likertl151', 'agree')">
                                            <label for="l1a1">Agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl151" type="radio" id="l1a2" name="likertl151" value="somewhat_agree" @click="sc('likertl151', 'somewhat_agree')">
                                            <label for="l1a2">Somewhat agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl151" type="radio" id="l1a3" name="likertl151" value="somewhat_disagree" @click="sc('likertl151', 'somewhat_disagree')">
                                            <label for="l1a3">Somewhat disagree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl151" type="radio" id="l1a4" name="likertl151" value="disagree" @click="sc('likertl151', 'disagree')">
                                            <label for="l1a4">Disagree</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="statement">I expect that future generations will want to explore other opportunities and career aspirations.
                                    <ul class='likert'>
                                        <li>
                                            <input v-model="likertl152" type="radio" id="l2a1" name="likertl152" value="agree" @click="sc('likertl152', 'agree')">
                                            <label for="l2a1">Agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl152" type="radio" id="l2a2" name="likertl152" value="somewhat_agree" @click="sc('likertl152', 'somewhat_agree')">
                                            <label for="l2a2">Somewhat agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl152" type="radio" id="l2a3" name="likertl152" value="somewhat_disagree" @click="sc('likertl152', 'somewhat_disagree')">
                                            <label for="l2a3">Somewhat disagree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl152" type="radio" id="l2a4" name="likertl152" value="disagree" @click="sc('likertl152', 'disagree')">
                                            <label for="l2a4">Disagree</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="statement">I expect that future generations will continue to be responsible for the day-to-day operations.
                                    <ul class='likert'>
                                        <li>
                                            <input v-model="likertl153" type="radio" id="l3a1" name="likertl153" value="agree" @click="sc('likertl153', 'agree')">
                                            <label for="l3a1">Agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl153" type="radio" id="l3a2" name="likertl153" value="somewhat_agree" @click="sc('likertl153', 'somewhat_agree')">
                                            <label for="l3a2">Somewhat agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl153" type="radio" id="l3a3" name="likertl153" value="somewhat_disagree" @click="sc('likertl153', 'somewhat_disagree')">
                                            <label for="l3a3">Somewhat disagree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl153" type="radio" id="l3a4" name="likertl153" value="disagree" @click="sc('likertl153', 'disagree')">
                                            <label for="l3a4">Disagree</label>
                                        </li>
                                    </ul>
                                </li>
                                <li class="statement">We can find a rewarding place for any family member who wants to work in the family business
                                    <ul class='likert'>
                                        <li>
                                            <input v-model="likertl154" type="radio" id="l4a1" name="likertl154" value="agree" @click="sc('likertl154', 'agree')">
                                            <label for="l4a1">Agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl154" type="radio" id="l4a2" name="likertl154" value="somewhat_agree" @click="sc('likertl154', 'somewhat_agree')">
                                            <label for="l4a2">Somewhat agree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl154" type="radio" id="l4a3" name="likertl154" value="somewhat_disagree" @click="sc('likertl154', 'somewhat_disagree')">
                                            <label for="l4a3">Somewhat disagree</label>
                                        </li>
                                        <li>
                                            <input v-model="likertl154" type="radio" id="l4a4" name="likertl154" value="disagree" @click="sc('likertl154', 'disagree')">
                                            <label for="l4a4">Disagree</label>
                                        </li>
                                    </ul>
                                </li>

                            </ul>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('1.4')">Previous</a>
                                <a class="next" @click="showTile('1.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('1.6')">
                        <span class="item-number">6</span>
                        <div v-if="!isOpened('1.6')" class="preview" @click="showTile('1.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo84700946.jpg'" alt="Founder to siblings ">
                            </div>
                            <div class="description">
                                <strong>Founder to siblings</strong> <!--Strong family communication is the key to business success. Listen to Philippe de Gaspé Beaubien share his experiences and insights on how he and his siblings have maintained a strong relationship while thriving as a business family.-->
                            </div>
                        </div>
                        <div v-if="isOpened('1.6')" class="item-content">
                            <div class="block">
                                <h1>Sibling Partnership: Making It Work</h1>
                                <div class="res-author">Philippe de Gaspé Beaubien III</div>
                                <div class="res-date">Published: Feb 4, 2014</div> 
                                
                                <p>Strong family communication is the key to business success. Listen to Philippe de Gaspé Beaubien share his experiences and insights on how he and his siblings have maintained a strong relationship while thriving as a business family.</p>

                                <iframe src="https://player.vimeo.com/video/84700946?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/sibling-rivalry-an-advisors-perspective/" target="_blank">Sibling Rivalry – an Advisor’s Perspective</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('1.5')">Previous</a>
                                    <a class="next" @click="nextStep(); showTile('2.1')">Next</a>
                                </div>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>









            <div v-if="step == 2">
                <h1 v-if="openedTile === 0">Clarifying the Goals and Priorities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('2.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('2.1')" class="preview" @click="showTile('2.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What business governance structures currently exist?">
                            </div>
                            <div class="description">
                                <strong>What business governance structures currently exist?</strong> <!--Read how in the authors's combined 70 years’ experience as advisers and confidantes of family businesses, they have come across a number of exceptional examples of families who have been struck by terrible external shocks to their business—whether at the hands of rivals, government or broader economic forces—only to reinvent themselves, and in the process become more successful, more resilient and closer as a family.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.1')" class="item-content">
                            <div class="block">
                                <h2>Does the family business have any of the following governance structures set-up?</h2>
                                
                                <ul class="quiz">
                                    <li :class="(q21 == 1 ? 'checked' : '')" @click="sc('q21', 1)">Board of Directors</li>
                                    <li :class="(q21 == 2 ? 'checked' : '')" @click="sc('q21', 2)">Advisory Board</li>
                                    <li :class="(q21 == 3 ? 'checked' : '')" @click="sc('q21', 3)">None of these</li>
                                </ul>
                                
                            </div>  

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://www.campdenfb.com/article/does-your-family-business-need-war-room" target="_blank">Does your family business need a war room?</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('1.6')">Previous</a>
                                <a class="next" @click="showTile('2.2')">Next</a>
                            </div>
  
                        </div>
                    </li>
                    <li :class="statusClass('2.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('2.2')" class="preview" @click="showTile('2.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Review business priorities and goals">
                            </div>
                            <div class="description">
                                <strong>Review business priorities and goals</strong> <!--Strategic planning is an essential part of the succesison process. Not only to reflect on previous strategies, but to begin forming new ones as new family members join the business and/or ownerhsip group.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.2')" class="item-content">
                            
                            <h1>The Business Planning Process Diagram</h1>

                            <iframe :src="baseurl + 'assets/pdf/business/The-Business-Planning-Process-Diagram.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Download</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/business/The-Business-Planning-Process-Diagram.pdf'" target="_blank">Strategic Business Planning Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.1')">Previous</a>
                                <a class="next" @click="showTile('2.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('2.3')" class="preview" @click="showTile('2.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo79684084.jpg'" alt="Begin building an independent Board of Advisors & Directors">
                            </div>
                            <div class="description">
                                <strong>Begin building an independent Board of Advisors & Directors</strong> <!--Listen to Dr. Joseph Astrachan, as he suggests a step by step process to develop a Board of Directors for a family business. In a family business, it is beneficial to develop a a form of governance as soon as possible. Governance plays a key role in a family business when the business begins to mature and the development of ideas slows down. A system of governance in a family business is key to its long-term success.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.3')" class="item-content">
                            
                            <div class="col">
                                <h2>Developing a Board of Directors for the Family Business</h2>
                                <p>Watch Dr. Joseph Astrachan, who teaches family business at Kennesaw State University, as he suggests a step by step process to develop a Board of Directors for a family business. In a family business, it is beneficial to develop a a form of governance as soon as possible. Governance plays a key role in a family business when the business begins to mature and the development of ideas slows down. A system of governance in a family business is key to its long-term success.</p>

                                <iframe src="https://player.vimeo.com/video/79684084?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>
                            <div class="col">
                                <h2>The Importance of a Board of Directors in a Family Business</h2>
                                <p>Listen to Harry Martin, a Family Business Advisor and Family Office Expert, explain why an independent Board of Directors in a Family Business is necessary. In several family businesses, a controlling patriarch tends to make all the decisions in the business, thinking they know what is best for the business. Setting up an independent board of directors is essential in generating an objective opinion of the CEO’s performance.</p>

                                <iframe src="https://player.vimeo.com/video/62252589?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/advisory-boards-and-what-family-businesses-need-to-consider/" target="_blank">Advisory Boards and What Family Businesses Need to Consider</a></li>
                                </ul>
                            </div>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.2')">Previous</a>
                                <a class="next" @click="showTile('2.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('2.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('2.4')" class="preview" @click="showTile('2.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/vimeo148114978.jpg'" alt="In the context of changing landscape what kind of skills a renewed board needs?">
                            </div>
                            <div class="description">
                                <strong>In the context of changing landscape what kind of skills a renewed board needs?</strong> <!--Hear how one experts encourgaes families to complement the C-Suite skilss with F-Suite capabilities. Could this be the successful formula for your family?-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.4')" class="item-content">
                            
                            <div class="block">
                                <h1>C-Suite Hardware with F-Suite Software</h1>
                                <div class="res-author">Justin Craig</div>
                                <div class="res-date">Published: Jan 4, 2016</div>
                                
                                <p>Justin Craig encourages complementing the C-Suite skills with F-Suite capabilities.</p>

                                <iframe src="https://player.vimeo.com/video/148114978?dnt=1&amp;app_id=122963" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen=""></iframe>

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/important-skills-for-a-female-leader-to-develop-from-a-young-age/" target="_blank">Important Skills for a Female Leader to Develop From a Young Age</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('2.3')">Previous</a>
                                    <a class="next" @click="showTile('2.5')">Next</a>
                                </div>

                            </div>
                        </div>
                        
                    </li>
                    <!--li :class="statusClass('2.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('2.5')" class="preview">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Develop a process for clear and transparent reporting">
                            </div>
                            <div class="description">
                                <strong>Develop a process for clear and transparent reporting</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('2.5')" class="item-content">
                            <p>Coming soon</p>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('2.4')">Previous</a>
                                <a class="next" @click="showTile('2.6')">Next</a>
                            </div>
                        </div>
                        
                    </li-->

                    <li :class="statusClass('2.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('2.5')" class="preview" @click="showTile('2.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Avoid entitlement through business access requirements for family members">
                            </div>
                            <div class="description">
                                <strong>Avoid entitlement through business access requirements for family members</strong> <!--In the absence of a succession plan, nepotism takes over. Those with the loudest voice, or most egotistic or aggressive personalities, can force their way into the executive suite. This can lead to catastrophic results where non-family and family staff leave, customers and suppliers start to question the future of their relationships, and bankers and investors start to worry about the safety of their capital.-->
                            </div>
                        </div>
                        <div v-if="isOpened('2.5')" class="item-content">
                            
                            <div class="block">

                                <h1 class="res-title">Risk of Nepotism?</h1>
                                <div class="res-date">Published: Feb 22, 2022</div>  
                                
                                <p>I just watched the show Succession.&nbsp;Episode 2 is a lot of fun to watch. The 80 year old billionaire media patriarch has a brain seizure, becomes unconscious and is hospitalized in the ICU.&nbsp; Almost immediately, right in the hospital, every one of his shallow and inept sons lobby themselves to take over as the new CEO.&nbsp;To get board approval, two of the sons team up as CEO and COO.&nbsp;But that does not inspire any shareholder confidence, and the share price plummets, causing a breach of loan covenants. &nbsp;&nbsp;&nbsp;</p>

                                <p>Fiction is pretty close to fact in this instance.&nbsp;In the absence of a well thought out succession plan, where a deserving successor has been selected and groomed to take over as the future leader, there can be a huge gap created when an incumbent leader has a sudden and material health catastrophe or, worse, passes away suddenly.</p>

                                <p>In the absence of a succession plan, nepotism takes over.&nbsp;Those with the loudest voice, or most egotistic or aggressive personalities, can force their way into the executive suite.&nbsp;This can lead to catastrophic results where non-family and family staff leave, customers and suppliers start to question the future of their relationships, and bankers and investors start to worry about the safety of their capital.</p>

                                <p>Often, families place family members in senior management roles simply because they feel they have a right, notwithstanding a lack of merit or needed skillset.&nbsp;&nbsp; Merit includes training and education, work experience and ethic, vision, and strong collegiate leadership skills.&nbsp;</p>

                                <p>A family enterprise continuity plan requires the right person in the right job.&nbsp; And it requires timely and effective performance appraisals to provide constructive feedback, and compensation based on goal attainment.&nbsp; It should not reward mediocrity, or permit substandard performance to carry on without remediation or a change of staff member.&nbsp;</p>

                                <p>Nepotism can seriously challenge the continuity of a healthy family enterprise, and alienate all of the parties with an interest in the best outcome.</p>

                                <p>A family enterprise needs a leader with the skills training, and leadership qualities to not only motivate the staff, but also bring the necessary vision, values, and strategy for leading the way forward. &nbsp;And part of the job description of any current leader should include the development of a continuity plan for the replacement of the most senior members of the management team, as this can take a lot of time and advance thought.</p>

                                <p>Nepotism can kill a family enterprise, or at the very least set it back in the eyes of its most interested parties, including family members, management, suppliers, bankers, and other shareholders. Of late, we have seen a number of board battles caused by nepotism at the expense of independent board decision making.&nbsp; In the absence of good governance, there are no checks and balances to assure the best decisions. &nbsp;&nbsp;Sometimes families resort to the courts to force a change when mired in nepotism. Invariably it reflects poorly on the family, and incurs a lot of legal fees and negative publicity.</p>

                                <p>Of course, in practice, too few families use professional management or objective appraisal techniques to ensure good performance over right and privilege.&nbsp; But the most successful family enterprises in existence over the generations realize that the human resource skills population available from non-family outsiders is far greater than within the family, and can heighten the likelihood of the achievement of long term success and continuity when working with family members.</p>

                                <p>So the question each family enterprise must ask at some point is, do we really have the best talent to succeed.&nbsp; And if not, are we willing to hire, reward and retain the best people?</p>

                                <p><strong>Decision Tree Question: Are You Ready to Hire, Reward and Retain the Best People?</strong></p>
  

                                <div class="additional-resources">
                                    <h3>Additional Resources</h3>
                                    <ul>
                                        <li class="video"><a href="https://familyenterprise.ca/resource/entitlement-vs-meritocracy/" target="_blank">Entitlement vs. Meritocracy</a></li>
                                    </ul>
                                </div>

                                <div :class="'nav nav'+path">
                                    <a class="previous" @click="showTile('2.4')">Previous</a>
                                    <a class="next" @click="nextStep(); showTile('3.1')">Next</a>
                                </div>
                            </div>

                        </div>
                        
                    </li>
                </ul>
            </div>




            <div v-if="step == 3">
                <h1 v-if="openedTile === 0">Reviewing Business Strategy</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('3.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('3.1')" class="preview" @click="showTile('3.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What are your current, values, vision and mission for the business? How do they align with the family VMV?">
                            </div>
                            <div class="description">
                                <strong>What are your current, values, vision and mission for the business? How do they align with the family VMV?</strong> <!--It is critical to discuss the challenges in decision making when combining family and business. In order to effectively discuss long-term decisions for the business, including business values, compensation methods and succession planning, is it important that management, ownership and the family are aligned. Cooperation and agreement between these three groups will help create clarity in the future of the business.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.1')" class="item-content">
                            <div class="block">
                                <h1>What Do We Stand for As a Business?</h1>

                                <iframe :src="baseurl + 'assets/pdf/business/What-Do-We-Stand-For-As-A-Business.pdf'" class="pdf"></iframe>

                            </div>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/business/What-Do-We-Stand-For-As-A-Business.pdf'" target="_blank">What Do We Stand For As A Business - PDF Template</a></li>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/family-values-setting-a-stable-course-for-the-business/" target="_blank">Family Values: Setting a Stable Course for the Business</a></li>
                                    <li class="video"><a href="https://familyenterprise.ca/resource/ensuring-compatibility-with-the-existing-business-through-values-culture/" target="_blank">Ensuring Compatibility with the Existing Business Through Values & Culture</a></li>
                                </ul>
                            </div>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('2.6')">Previous</a>
                                <a class="next" @click="showTile('3.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('3.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('3.2')" class="preview" @click="showTile('3.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Get buy in from all levels of executive and/or management on VMV">
                            </div>
                            <div class="description">
                                <strong>Get buy in from all levels of executive and/or management on VMV</strong> <!--We have already looked at the benefits of having shared values, here are the benefits of sharing values throughout your entire organization.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.2')" class="item-content">
                            
                            <div class="audio">
                
                                <h1>Instilling Values Throughout the Company</h1>
                                
                                <audio ref="audio32" @timeupdate="onTimeUpdate" controls class="compass" id="audio32" :src="baseurl + 'assets/audios/camp1path2step3tile2.mp3'"></audio>
                                
                                <div class="transcript">
                                    <p>In the last section, we looked at the benefits of having shared values in the ownership group, here are the benefits of sharing values throughout your entire organization.</p>
                                </div>
                            </div>
                           
                           
                            <div class="slide3-2">
                                
                                <div class="power-element">
                                    <p class="element-label">Providing a template for decision-making</p>
                                </div>
                                            
                                <div class="col-sm-7 element-description">
                                    <p>Values are critical when making decisions; employees and managers can handle situations without direct supervision from the owners.</p>
                                </div>
                                       
                                
                                <div class="power-element">
                                    <p class="element-label">Executing strategy</p>
                                </div>
                                        
                                <div class="col-sm-7 element-description">
                                    <p>When strategy is based on values, people will be more ready and willing to implement it.</p>
                                </div>
                                    
                                <div class="power-element">
                                    <p class="element-label">Making work meaningful</p>
                                </div>
                                        
                                <div class="col-sm-7 element-description">
                                    <p>Values give meaning to the work, for everyone from owner’s, to managers, to employees. This leads to higher employee performance.</p>
                                </div>
                                 
                                <div class="power-element">
                                    <p class="element-label">Recruiting and Retaining Employees</p>
                                </div>
                                
                                <div class="col-sm-7 element-description">
                                    <p>Workers are more likely to join, and stay on with, a company with strong, shared values.</p>
                                </div>
                                
                            </div>

                            
                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/ownership/values-takeaway-sheets.pdf'" target="_blank">Values Takeaway Template</a></li>
                                </ul>
                            </div>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.1')">Previous</a>
                                <a class="next" @click="showTile('3.3')">Next</a>
                            </div>


                        </div>
                    </li>
                    <li :class="statusClass('3.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('3.3')" class="preview" @click="showTile('3.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Create a risk assessment and contingency plan">
                            </div>
                            <div class="description">
                                <strong>Create a risk assessment and contingency plan</strong> <!--Uncertainty and risk, two key elements of any continuity plan that need to be frt and center and openly discussed. Here, Charles Ellis differentiates risk from uncertainty and talks about dealing with each.-->
                            </div>
                        </div>
                        <div v-if="isOpened('3.3')" class="item-content">
                            <h1>Contingency planning</h1>

                            <iframe :src="baseurl + 'assets/pdf/business/Contingency-Planning.pdf'" class="pdf"></iframe>


                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/business/Contingency-Planning.pdf'" target="_blank">Contingency planning Template</a></li>

                                    <li class="video"><a href="https://familyenterprise.ca/resource/uncertainty-vs-risk/" target="_blank">Uncertainty Vs. Risk</a></li>
                                </ul>
                            </div>


                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('3.2')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('4.1')">Next</a>
                            </div>
                        </div>
                    </li>


                </ul>
            </div>



            <div v-if="step == 4">
                <h1 v-if="openedTile === 0">Planning the Transition of Responsibilities</h1>
                
                <ul class="progress-line">
                    <li :class="statusClass('4.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('4.1')" class="preview" @click="showTile('4.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/hbr.jpg'" alt="Build an experienced transition management team">
                            </div>
                            <div class="description">
                                <strong>Build an experienced transition management team</strong> <!--Change is intensely personal. For change to occur in any organization, each individual must think, feel, or do something different. Even in large organizations, which depend on thousands of employees understanding company strategies well enough to translate them into appropriate actions, leaders must win their followers one by one.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.1')" class="item-content">
                            <h1>Managing Change: The Art of Balancing</h1>

                            <a href="https://hbr.org/1993/11/managing-change-the-art-of-balancing" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-2-4.1.jpg'" style="max-width: 80%; height: 100%;" alt="">
                            </a>


                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://www.mckinsey.com/capabilities/people-and-organizational-performance/our-insights/successfully-transitioning-to-new-leadership-roles" target="_blank">Successfully transitioning to new leadership roles</a></li>
                                </ul>
                            </div>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('3.3')">Previous</a>
                                <a class="next" @click="showTile('4.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('4.2')" class="preview" @click="showTile('4.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Plan a structured onboading process including: reviewing past and present conceptual and strategic plans">
                            </div>
                            <div class="description">
                                <strong>Plan a structured onboading process including: reviewing past and present conceptual and strategic plans</strong> <!--Use this template to develop your own family business onboarding process. Be sure to consult relevant family members and key manaegment in order to create a holstic plan-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.2')" class="item-content">
                            <h1>Plan a structured onboading process including: reviewing past and present conceptual and strategic plans</h1>

                            <a href="https://avenueleadership.com/executive-onboarding-program/executive-onboarding-and-transition-timeline-toolkit-plans-and-templates/" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/Executive-Onboarding.png'" style="max-width: 50%; height: 100%;" alt="">
                            </a>

                            

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.1')">Previous</a>
                                <a class="next" @click="showTile('4.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('4.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('4.3')" class="preview" @click="showTile('4.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Set Duties, Responsibilities, and Expectations and of CEO">
                            </div>
                            <div class="description">
                                <strong>Set Duties, Responsibilities, and Expectations and of CEO</strong> <!--At the top of the ladder, the stakes are high and the demands intense. Too many CEOs falter in the job; about a quarter of the Fortune 500 chiefs who leave their firms each year are forced out. Clearly, boards do not always get their hires right.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.3')" class="item-content">
                            <h1>Office of the CEO</h1> 

                            <iframe :src="baseurl + 'assets/pdf/business/Office-of-the-CEO.pdf'" class="pdf"></iframe>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="pdf"><a :href="baseurl + 'assets/pdf/business/Office-of-the-CEO.pdf'" target="_blank">Office of the CEO - Template</a></li>

                                    <li class="link"><a href="https://hbr.org/2017/05/what-sets-successful-ceos-apart" target="_blank">What Sets Successful CEOs Apart</a></li>
                                </ul>
                            </div>



                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.2')">Previous</a>
                                <a class="next" @click="showTile('4.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <!--li :class="statusClass('4.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('4.4')" class="preview">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Get realistic business forecasts from management (remember that there is no right or wrong numbers, just credible ones)">
                            </div>
                            <div class="description">
                                <strong>Get realistic business forecasts from management (remember that there is no right or wrong numbers, just credible ones)</strong> 
                            </div>
                        </div>
                        <div v-if="isOpened('4.4')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.3')">Previous</a>
                                <a class="next" @click="showTile('4.5')">Next</a>
                            </div>
                        </div>
                        
                    </li-->

                    <li :class="statusClass('4.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('4.4')" class="preview" @click="showTile('4.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/hbr.jpg'" alt="Implement one rule: chairman and CEO cannot be the same person">
                            </div>
                            <div class="description">
                                <strong>Implement one rule: chairman and CEO cannot be the same person</strong> <!--Recent debacles at Boeing, WeWork, and Facebook illustrate why organizations should be wary of giving the CEO job and the board chair job to one person. These cases also confirm what the authors have learned from interviews with accomplished tech industry CEOs, board chairs, investors and founders: As a leadership practice, the Two Job – One Person model can deny the organization talent at the top and lead to blind spots that undermine the organization’s ability to manage risks.-->
                            </div>
                        </div>
                        <div v-if="isOpened('4.4')" class="item-content">
                            <h1>Why the CEO Shouldn’t Also Be the Board Chair</h1>

                            <a href="https://hbr.org/2020/03/why-the-ceo-shouldnt-also-be-the-board-chair" target="_blank" class="play-link">
                                <span>Click here to read more</span>
                                <img :src="baseurl + 'assets/images/camp1-2-4.5.jpg'" style="max-width: 80%; height: auto;" alt="Why the CEO Shouldn’t Also Be the Board Chair">
                            </a>

                            <div class="additional-resources">
                                <h3>Additional Resources</h3>
                                <ul>
                                    <li class="link"><a href="https://www.imd.org/research-knowledge/articles/the-four-tiers-of-conflict-of-interest-faced-by-board-directors/" target="_blank">The four tiers of conflict of interest faced by board directors</a></li>
                                </ul>
                            </div>
    

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('4.3')">Previous</a>
                                <a class="next" @click="nextStep(); showTile('5.1')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                </ul>
            </div>






            <div v-if="step == 5">
                <h1 v-if="openedTile === 0">Transitioning Business Value & Control</h1>
                
                <p>As a development bank, BDC has been working with entrepreneurs for over 65 years to develop business plans that help them succeed. Their business plan template is designed to allow you to prepare a professional plan, and take your business to the next level toward growth and success.</p>

                <h2>BDC business plan template for entrepreneurs</h2>
                <p><strong>Instructions</strong></p>
                <ol>
                    <li>The template is provided as a reference only. Not all sections will be relevant for your company and you may need to modify it substantially for it to respond to your needs.</li>
                    <li>Ideas for what to write were provided (in red) for every section. Delete this page as well as the instructions provided in every section before finalizing your business plan.</li>
                    <li>The BDC business plan template was primarily created using the Microsoft Word software. You may encounter formatting and other problems if you are using other software.</li>
                    <li>Write simply and concisely. Consider using bullets instead of paragraphs.</li>
                    <li>It is best to avoid repetition, if possible.</li>
                    <li>Your business plan is not a static document. You will need to review it regularly and adjust it to reflect changing conditions. </li>
                </ol>

                <div class="additional-resources">
                    <h3>Additional Resources</h3>
                    <ul>
                        <li class="link"><a href="https://www.imd.org/research-knowledge/articles/the-four-tiers-of-conflict-of-interest-faced-by-board-directors/'" target="_blank">The four tiers of conflict of interest faced by board directors</a></li>
                        
                        <li class="link"><a :href="baseurl + 'assets/pdf/business/BDC-Business-Plan-Template-Kit-AP-to-AT/1-Blank-Business-Plan-Template.docx'" target="_blank">Blank Business Plan Template.docx</a></li>
                        <li class="link"><a :href="baseurl + 'assets/pdf/business/BDC-Business-Plan-Template-Kit-AP-to-AT/1-Blank-Financial-Appendix.xlsx'" target="_blank">Blank Financial Appendix</a></li>
                        <li class="link"><a :href="baseurl + 'assets/pdf/business/BDC-Business-Plan-Template-Kit-AP-to-AT/2-Example-Financial-Appendix.pdf'" target="_blank">Example Financial Appendix</a></li>
                        <li class="link"><a :href="baseurl + 'assets/pdf/business/BDC-Business-Plan-Template-Kit-AP-to-AT/2-Example-Business-Plan.pdf'" target="_blank">Example Business Plan</a></li>
                        <li class="link"><a href="https://www.bdc.ca/en/articles-tools/start-buy-business/start-business/pages/business-plan-how-avoid-common-mistakes.aspx?ref=related-articles" target="_blank">How to avoid common mistakes</a></li>
                        <li class="link"><a href="https://www.bdc.ca/en/articles-tools/start-buy-business/start-business/pages/how-write-business-plan.aspx" target="_blank">How to write a business plan</a></li>

                    </ul>
                </div>


            </div>


            <div v-if="step == 6">
                <h1 v-if="openedTile === 0">Financing the Succession</h1>
                
                Coming soon...

                <!--ul class="progress-line">
                    <li :class="statusClass('5.1')">
                        <span class="item-number">1</span>
                        <div v-if="!isOpened('5.1')" class="preview" @click="showTile('5.1')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What is your family's competitive advantage? Focus on intangible assets (talent, relationships, social and spiritual capital)">
                            </div>
                            <div class="description">
                                <strong>What is your family's competitive advantage? Focus on intangible assets (talent, relationships, social and spiritual capital)</strong> Coming soon.
                            </div>
                        </div>
                        <div v-if="isOpened('5.1')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="previousStep(); showTile('4.5')">Previous</a>
                                <a class="next" @click="showTile('5.2')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.2')">
                        <span class="item-number">2</span>
                        <div v-if="!isOpened('5.2')" class="preview" @click="showTile('5.2')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="What is your family's competitive advantage? Set of questions">
                            </div>
                            <div class="description">
                                <strong>What is your family's competitive advantage? Set of questions</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('5.2')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.1')">Previous</a>
                                <a class="next" @click="showTile('5.3')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.3')">
                        <span class="item-number">3</span>
                        <div v-if="!isOpened('5.3')" class="preview" @click="showTile('5.3')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Build Family Trust (specify financial/legal)">
                            </div>
                            <div class="description">
                                <strong>Build Family Trust (specify financial/legal)</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('5.3')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.2')">Previous</a>
                                <a class="next" @click="showTile('5.4')">Next</a>
                            </div>
                        </div>
                    </li>
                    <li :class="statusClass('5.4')">
                        <span class="item-number">4</span>
                        <div v-if="!isOpened('5.4')" class="preview" @click="showTile('5.4')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Create family bonding experiences ( make suggestions)">
                            </div>
                            <div class="description">
                                <strong>Create family bonding experiences ( make suggestions)</strong> Coming soon.
                            </div>
                        </div>
                        <div v-if="isOpened('5.4')" class="item-content">
                            <p>Coming soon</p>

                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.3')">Previous</a>
                                <a class="next" @click="showTile('5.5')">Next</a>
                            </div>
                        </div>
                        
                    </li>
                    <li :class="statusClass('5.5')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.5')" class="preview" @click="showTile('5.5')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Task force to individually interview all family members about their dreams, ambitions...">
                            </div>
                            <div class="description">
                                <strong>Task force to individually interview all family members about their dreams, ambitions...</strong> Coming soon.
                            </div>
                        </div>
                        <div v-if="isOpened('5.5')" class="item-content">
                            <p>Coming soon</p>
                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.4')">Previous</a>
                                <a class="next" @click="showTile('5.6')">Next</a>
                            </div>
                        </div>
                        
                    </li>

                    <li :class="statusClass('5.6')">
                        <span class="item-number">5</span>
                        <div v-if="!isOpened('5.6')" class="preview" @click="showTile('5.6')">
                            <div class="thumbnail">
                                <img :src="baseurl + 'assets/images/placeholder.jpg'" alt="Determine the level of emotionnal ownership that exists - defining 'familyness'">
                            </div>
                            <div class="description">
                                <strong>Determine the level of emotionnal ownership that exists - defining 'familyness'</strong> Coming soon
                            </div>
                        </div>
                        <div v-if="isOpened('5.6')" class="item-content">
                            <p>Coming soon</p>
                            <div :class="'nav nav'+path">
                                <a class="previous" @click="showTile('5.5')">Previous</a>
                                <a class="next hide"></a>
                            </div>
                        </div>
                        
                    </li>
                </ul-->
            </div>

            <!--a v-if="step > 1 && openedTile === 0" :class="'prev path' + path" @click="previousStep()">Previous</a>
            <a v-if="step < 6 && openedTile === 0" :class="'next path' + path" @click="nextStep()">Next</a-->
            


        </div>
    </div>
  </div>
</template>

<script>

function setCookie(name, value, minutes) {
  var expires;
  if (minutes) {
    var date = new Date();
    date.setTime(date.getTime() + (minutes * 60 * 1000));
    expires = "; expires=" + date.toGMTString();
  } else {
    expires = "";
  }
  document.cookie = name + "=" + value + expires + "; path=/";
}

// Read cookie
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
}

export default {
  name: "camp1-path2",
  components: {

  },
  data() {
    return {
      tile: 1,
      openedTile: 0,
      completedTiles:  (getCookie("completedTiles2") ? JSON.parse(getCookie("completedTiles2")) : []),
      path: 2,
      progress1: 0,
      progress2: 0,
      progress3: 0,
      progress4: 0,
      progress5: 0,
      q21: (getCookie("q21") ? getCookie("q21") : 0),
      q11: (getCookie("q11") ? getCookie("q11") : 0),
      likertl151: (getCookie("likertl151") ? getCookie("likertl151") : 0),
      likertl152: (getCookie("likertl152") ? getCookie("likertl152") : 0),
      likertl153: (getCookie("likertl153") ? getCookie("likertl153") : 0),
      likertl154: (getCookie("likertl154") ? getCookie("likertl154") : 0),

      likertl111: (getCookie("likertl111") ? getCookie("likertl111") : 0),
      likertl112: (getCookie("likertl112") ? getCookie("likertl112") : 0),
      likertl113: (getCookie("likertl113") ? getCookie("likertl113") : 0),

      
    };
  },
  props: ["vimeoPause","vimeoPlay","vimeoGoTo","voidPath", "step"],
  computed: {
   
  },
  methods: {

    sc(c,v) {
        if (c == "q21") { this.q21 = v; }
        if (c == "q11") { this.q11 = v; }
        if (c == "likertl151") { this.likertl151 = v; }
        if (c == "likertl152") { this.likertl152 = v; }
        if (c == "likertl153") { this.likertl153 = v; }
        if (c == "likertl154") { this.likertl154 = v; }

        if (c == "likertl111") { this.likertl111 = v; }
        if (c == "likertl112") { this.likertl112 = v; }
        if (c == "likertl113") { this.likertl113 = v; }
        
        
        setCookie(c,v);
    },
   
    statusClass(t) {
        let c = '';

        if (this.isCompleted(t)) {
            c = c + ' done ';
        }
        
        if (this.activeTile(t)) {
            c = c + ' active ';
        }
        
        return c;
    }, 

    getProgress(s) {
        let p = 0;

        switch (s) {
            case 1:
                if (this.completedTiles.includes('1.1')) { p += 20; }
                if (this.completedTiles.includes('1.2')) { p += 20; }
                if (this.completedTiles.includes('1.3')) { p += 20; }
                if (this.completedTiles.includes('1.4')) { p += 20; }
                if (this.completedTiles.includes('1.5')) { p += 20; }
                //if (this.completedTiles.includes('1.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress1 = p;
                break;

            case 2:
                if (this.completedTiles.includes('2.1')) { p += 20; }
                if (this.completedTiles.includes('2.2')) { p += 20; }
                if (this.completedTiles.includes('2.3')) { p += 20; }
                if (this.completedTiles.includes('2.4')) { p += 20; }
                if (this.completedTiles.includes('2.5')) { p += 20; }
                //if (this.completedTiles.includes('2.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress2 = p;
                break;

            case 3:
                if (this.completedTiles.includes('3.1')) { p += 33.5; }
                if (this.completedTiles.includes('3.2')) { p += 33.5; }
                if (this.completedTiles.includes('3.3')) { p += 33.5; }
                // if (this.completedTiles.includes('3.4')) { p += 17; }
                // if (this.completedTiles.includes('3.5')) { p += 17; }
                // if (this.completedTiles.includes('3.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress3 = p;
                break;

            case 4:
                if (this.completedTiles.includes('4.1')) { p += 25; }
                if (this.completedTiles.includes('4.2')) { p += 25; }
                if (this.completedTiles.includes('4.3')) { p += 25; }
                if (this.completedTiles.includes('4.4')) { p += 25; }
                //if (this.completedTiles.includes('4.5')) { p += 20; }
                if (p > 100) { p = 100; }
                this.progress4 = p;
                break;

            case 5:
                if (this.completedTiles.includes('5.1')) { p += 100; }
                // if (this.completedTiles.includes('5.2')) { p += 17; }
                // if (this.completedTiles.includes('5.3')) { p += 17; }
                // if (this.completedTiles.includes('5.4')) { p += 17; }
                // if (this.completedTiles.includes('5.5')) { p += 17; }
                // if (this.completedTiles.includes('5.6')) { p += 17; }
                if (p > 100) { p = 100; }
                this.progress5 = p;
                break;
        }

        return '';
    },

    goto(s) {
        this.step = s;
        this.vimeoGoTo(1, 2, s);
    },

    nextStep() {
        this.step = this.step + 1;
        this.vimeoGoTo(1, 2, this.step);
    },

    previousStep() {
        this.step = this.step - 1;
        this.vimeoGoTo(1, 2, this.step);
    },
    

    activeTile(t) {
        if (this.tile == t) {
            return true;
        }
        return false;
    },

    showTile(t) {
        
        if (this.openedTile) {
            this.closeTile()
        }

        this.tile = t;
        this.openedTile = t;
    },

    closeTile() {
        this.completed(this.openedTile);
        this.openedTile = 0;
        this.tile = 0;
    },

    isOpened(t) {
        if (this.openedTile == t) {
            return true;
        }
        return false;
    },

    completed(t) {

        if (!this.completedTiles.includes(t)) {
            this.completedTiles.push(t);
        }
        setCookie("completedTiles2", JSON.stringify(this.completedTiles));

        for (var i = 1; i < 6; i++) {
            this.getProgress(i);
        }
    },

    isCompleted(t) {
       
        if (this.completedTiles.includes(t)) {
            return true;
        }
        return false;
    },



    onTimeUpdate () {
        switch (this.tile) {
            case 3:
                this.currentTime =  Math.round(this.$refs.audio32.currentTime);
                switch (this.currentTime) {
                    case 0:
                        console.log("OK")
                        break;
                }

                break;
        }
    }

  }
};
</script>

<style scoped>


</style>
